import instance from "./auth";
import {
  BakedDataItem,
  AdjustmentData,
  TempCheckData,
  ProductionsData
} from "./types";

import type { AxiosResponse } from "axios";

export const fetchAccessToken = async (code: string) => {
  console.log(code);
  try {
    const response = await instance.get(`/access_token?code=${code}`);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchStoreData = async () => {
  try {
    const getTime = () => Date.now();
    const response = await instance.get(`/store_data/${getTime()}`);
    console.log("fetchStoreData: ", response.data);
    return response.data;
  } catch (error) {
    console.error("fetchStoreData error: ", error);
    throw error;
  }
};

export const uploadProducts = async (
  uploadBakeTableState: BakedDataItem[],
  idempotencyKey: string
): Promise<any> => {
  try {
    const response = await instance.post(
      "/upload_production",
      uploadBakeTableState,
      {
        headers: {
          "Idempotency-Key": idempotencyKey
        }
      }
    );
    return response;
  } catch (err: any) {
    if (err.response?.status === 409) {
      return err.response as AxiosResponse;
    }
    throw err;
  }
};

export const fetchProductPlanner = async () => {
  console.log("fetchProductPlanner...");
  try {
    const response = await instance.get(`/planned_production`);
    console.log("fetchProductPlanner: ", response.data);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchCurrentDayBakeData = async () => {
  try {
    const response = await instance.get(`/current_day_bake_data`);
    console.log("fetchCurrentDayBakeData: ", response.data);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchBakeData = async () => {
  try {
    const response = await instance.get(`/bake_data`);
    const bakedData = response.data;
    const currentDayBakedData = await fetchCurrentDayBakeData();

    // refactor this
    const currentDayBakedDataMap = currentDayBakedData.reduce(
      (map: { [x: string]: any }, item: BakedDataItem) => {
        map[item.PLU] = {
          already_made: item.already_made,
          H6: item.H6 ?? 0,
          H7: item.H7 ?? 0,
          H8: item.H8 ?? 0,
          H9: item.H9 ?? 0,
          H10: item.H10 ?? 0,
          H11: item.H11 ?? 0,
          H12: item.H12 ?? 0,
          H13: item.H13 ?? 0,
          H14: item.H14 ?? 0,
          H15: item.H15 ?? 0,
          H16: item.H16 ?? 0,
          H17: item.H17 ?? 0,
          H18: item.H18 ?? 0
        };
        return map;
      },
      {}
    );

    const currentDayBakedDataMapWaves = currentDayBakedData.reduce(
      (
        map: { [x: string]: any },
        item: { PLU: string | number; already_made_waves: any }
      ) => {
        map[item.PLU] = item.already_made_waves || [];
        return map;
      },
      {}
    );
    const currentDayBakedDataMapDate = currentDayBakedData.reduce(
      (
        map: { [x: string]: any },
        item: { PLU: string | number; sent_date: number }
      ) => {
        map[item.PLU] = item.sent_date || 0;
        return map;
      },
      {}
    );

    // refactor this
    const updatedBakedData = bakedData.map((item: { PLU: string | number }) => {
      const dataMap = currentDayBakedDataMap[item.PLU] || {};
      const hours = Array.from({ length: 13 }, (_, i) => `H${6 + i}`);

      const waveCompareArray = hours.map((hour) => dataMap[hour] ?? 0);

      const hourData = Object.fromEntries(
        hours.map((hour) => [hour, dataMap[hour] ?? 0])
      );

      return {
        ...item,
        ...hourData,
        already_made: dataMap.already_made ?? 0,
        already_made_waves: currentDayBakedDataMapWaves[item.PLU] || [],
        sent_date: currentDayBakedDataMapDate[item.PLU] || 0
      };
    });

    console.log("fetchBakeData: ", updatedBakedData);

    return updatedBakedData;
  } catch (error) {
    console.error("fetchBakeData error: ", error);
    throw error;
  }
};

export const fetchUserInfo = async () => {
  try {
    const response = await instance.get(`/user_info`);
    console.log("fetchUserInfo: ", response.data);
    return response.data;
  } catch (error) {
    console.error(error);
    console.log("fetchUserInfo error: ", error);
    throw error;
  }
};

export const fetchPlanAdjustment = async () => {
  console.log("fetchPlanAdjustment...");
  try {
    const response = await instance.get(`/plan_adjustments`);
    console.log("fetchPlanAdjustment(): ", response.data);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const uploadPlanAdjustment = async (
  data: [AdjustmentData]
): Promise<any> => {
  try {
    const response = await instance.post(`/upload_plan_adjustment`, data);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchProductionsData = async () => {
  try {
    const response: { data: ProductionsData[] } = await instance.get(
      `/productions`
    );

    console.log("fetchProductionsData: ", response.data);

    return response.data;
  } catch (error) {
    console.error("fetchProductionsData error: ", error);
    return [];
  }
};

export const uploadRotationClearance = async (data: {
  PLU: number;
  timestamp: string;
  ClearanceTime?: string;
}): Promise<any> => {
  try {
    const response = await instance.post(`/upload_rotation_clearance`, data);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
